/* v5-group-membership-guard-2026-06-03 */
/**
 * sc-linked-styles: cross-product design preservation via sessionStorage.
 *
 * Storage keys:
 *  - `scls_last_<type>_<family>` — most recent visited per type, SCOPED theo family
 *    (SKU prefix vd "5272") để tránh cross-family bleed.
 *  - `scls_for_<targetHandle>_<sourceType>` — per-target scoped (legacy fallback).
 *
 * Flow:
 *  1. Load A → save scls_last_<A.type>_<family> + scls_for_<L>_<A.type> cho mỗi linked L.
 *  2. Load B → cho mỗi non-current card type T: read scls_last_<T>_<family> (priority) ||
 *     scls_for_<B>_<T> → fetch /products/{savedHandle}.js → swap card href + img + label + price.
 *  3. Pageshow (bfcache restore) → re-run init để storage sync với card display.
 */
(function () {
  function familyKey(handle) {
    /* Extract SC<digits> prefix → group products cùng family (Phone+Tough cùng SKU root).
       Vd: sc5272b02 và sc5272tc05 → cùng family "5272". sc50511b37 → "50511". */
    var m = (handle || '').toLowerCase().match(/sc(\d+)/);
    return m ? m[1] : '';
  }

  function key(target, type) {
    return 'scls_for_' + target + '_' + type;
  }

  function lastKey(type, family) {
    return 'scls_last_' + type + '_' + family;
  }

  function withWidth(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  function formatMoney(cents) {
    /* Shopify product.js trả price ở cents. Fallback hardcoded $ — KHÔNG dùng Shopify.formatMoney
       vì có thể chưa loaded. SHINYCUSTOM single-currency USD. */
    if (cents == null || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  /* Apply swapped product data to card DOM (href + label + price + img). */
  function swapCard(card, data) {
    card.classList.add('is-swapping');
    if (card.tagName === 'A') card.href = '/products/' + data.handle;
    var labelEl = card.querySelector('.sc-linked-styles__label');
    /* Label = style_label (lấy từ family-map SSR), KHỚP Liquid:
       p.metafields.custom.style_label | default: p.type | default: p.title.
       SLOW PATH (/products/<handle>.js) KHÔNG expose metafield style_label → không truyền
       data.label → GIỮ nhãn server-render (đã đúng style_label), KHÔNG đè bằng product.type. */
    if (labelEl && data.label) {
      var newLabel = data.label;
      labelEl.textContent = newLabel.length > 30 ? newLabel.slice(0, 30) + '…' : newLabel;
    }
    var priceEl = card.querySelector('.sc-linked-styles__price-current');
    if (priceEl && data.price != null) priceEl.textContent = formatMoney(data.price);
    var compareEl = card.querySelector('.sc-linked-styles__compare');
    if (compareEl) {
      if (data.compare_at_price && data.compare_at_price > data.price) {
        compareEl.textContent = formatMoney(data.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    var img = card.querySelector('.sc-linked-styles__img');
    if (img && data.featured_image) {
      var newSrc = withWidth(data.featured_image, 300);
      var done = function () { card.classList.remove('is-swapping'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      img.removeAttribute('srcset');
      img.src = newSrc;
    } else {
      card.classList.remove('is-swapping');
    }
  }

  function init() {
    var root = document.querySelector('.sc-linked-styles');
    if (!root) return;

    var currentHandle = root.dataset.currentHandle || '';
    var currentType = root.dataset.currentType || '';
    var linkedHandles = (root.dataset.linkedHandles || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    if (!currentHandle || !currentType) return;
    var currentFamily = familyKey(currentHandle);

    /* Pre-rendered family map (Liquid SSR) → instant swap không cần AJAX. */
    var familyMap = {};
    try { familyMap = JSON.parse(root.dataset.familyMap || '{}'); } catch (e) {}

    /* Save current visit → storage */
    try {
      linkedHandles.forEach(function (h) {
        if (h && h !== currentHandle) sessionStorage.setItem(key(h, currentType), currentHandle);
      });
      if (currentFamily) {
        sessionStorage.setItem(lastKey(currentType, currentFamily), currentHandle);
      }
    } catch (e) { /* private mode / quota */ }

    /* For each non-current card, attempt swap */
    var cards = root.querySelectorAll('.sc-linked-styles__card:not(.is-current)[data-product-type]');
    cards.forEach(function (card) {
      var type = card.dataset.productType;
      if (!type || type === currentType) return;

      var saved;
      try {
        /* Priority: family-scoped last > legacy scoped per-target. */
        saved = (currentFamily && sessionStorage.getItem(lastKey(type, currentFamily)))
             || sessionStorage.getItem(key(currentHandle, type));
      } catch (e) { return; }
      if (!saved || saved === currentHandle) return;

      /* Group-membership guard: saved phải thuộc nhóm linked của trang hiện tại
         (familyMap = SSR group, hoặc linkedHandles). Chặn orphan cùng số family
         bị swap nhầm — vd sc5272v3 (Tough Case riêng) lẫn vào nhóm sc5272b02
         (tough cases đúng = sc5272tc01..tc07). familyKey chỉ scope theo chữ số
         SKU nên 2 nhóm khác nhau cùng số "5272" share chung sessionStorage. */
      if (!familyMap[saved] && linkedHandles.indexOf(saved) < 0) return;

      /* FAST PATH: nếu saved handle có trong pre-rendered map → swap sync, không AJAX */
      var mapData = familyMap[saved];
      if (mapData && mapData.type === type) {
        if (currentFamily && familyKey(saved) !== currentFamily) return;  /* cross-family guard */
        swapCard(card, {
          handle: saved,
          featured_image: mapData.img,
          label: mapData.label,
          title: mapData.title,
          type: mapData.type,
          price: mapData.price,
          compare_at_price: mapData.compare || 0,
        });
        return;
      }

      /* SLOW PATH (fallback): saved handle KHÔNG có trong map (cross-family/uncommon).
         AJAX fetch để swap. */
      card.classList.add('is-swapping');
      fetch('/products/' + encodeURIComponent(saved) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.handle || data.type !== type) {
            card.classList.remove('is-swapping');
            return;
          }
          if (currentFamily && familyKey(data.handle) !== currentFamily) {
            card.classList.remove('is-swapping');
            return;
          }
          swapCard(card, data);
        })
        .catch(function () {
          card.classList.remove('is-swapping');
        });
    });
  }

  init();
  /* bfcache restore (Safari/Firefox back-forward cache) → re-run để pick up new storage. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) init();
  });
})();

/* Choose Background compact grid. Kept in this existing PDP asset so the
   LIVE-parity block adds no extra JavaScript request. */
(function () {
  function initChooseBackground(root) {
    if (!root || root.dataset.scCosReady === 'true') return;
    root.dataset.scCosReady = 'true';

    var grid = root.querySelector('.sc-cos__grid');
    if (!grid) return;

    var cards = grid.querySelectorAll('.sc-cos__card');
    var visibleCards = parseInt(grid.dataset.visibleCards, 10) || 0;
    var storageKey = 'sc-cos-expanded:' + (root.dataset.colHandle || '') + ':handle';

    function expand() {
      grid.classList.add('is-compact-expanded');
      cards.forEach(function (card) { card.classList.remove('is-compact-hidden'); });
      grid.querySelectorAll('img[data-sc-style-src]').forEach(function (image) {
        image.src = image.dataset.scStyleSrc;
        image.removeAttribute('data-sc-style-src');
      });
      try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
    }

    if (visibleCards > 0) {
      cards.forEach(function (card) {
        if (card.classList.contains('sc-cos__card--more') || card.classList.contains('is-current')) return;
        var rank = parseInt(card.dataset.cardRank, 10);
        card.classList.toggle('is-compact-hidden', !isNaN(rank) && rank >= visibleCards - 1);
      });
    }

    var more = grid.querySelector('[data-more-expand]');
    if (more) more.addEventListener('click', expand);

    try {
      if (sessionStorage.getItem(storageKey) === '1') expand();
    } catch (e) {}
  }

  document.querySelectorAll('[data-sc-cos]').forEach(initChooseBackground);
})();
